module.exports = __webpack_public_path__ + "static/media/Hero-Images.20782e35.png";